<login>
  <form onsubmit="{ onSubmit }" class="login-form">
    <input name="dummyemail" autocomplete="email" style="top: -2000px; left: -2000px; position: fixed;" type="text">
    <input type="password" name="dummypass" autocomplete="current-password"
      style="top: -2000px; left: -2000px; position: fixed;">

    <div class="form-group">
      <label class="form-label" for="mail">メールアドレス</label>
      <input class="form-control" type="text" name="mail" id="mail" value="{ state.mail }" required>
    </div>

    <div class="form-group">
      <label class="form-label" for="password">パスワード</label>
      <input class="form-control" type="password" name="password" id="password" value="{ state.password }" required>
    </div>

    <div class="form-group">
      <label for="showPasswordCheck">
        <input type="checkbox" name="showPasswordCheck" id="showPasswordCheck" onchange="{ togglePassword }">
        <small>パスワードを表示する</small>
      </label>
    </div>

    <div class="form-group">
      <label for="saveInputCheck">
        <input type="checkbox" name="saveInputCheck" id="saveInputCheck" checked="{ state.saveInputCheck }">
        <small>入力内容を保存する</small>
      </label>
    </div>

    <button class="btn btn-green login-btn">ログイン</button>

    <div class="link-group">
      <a class="link" href="#register">新規登録</a>
      <a class="link" href="#password">パスワードを忘れた場合</a>
    </div>
  </form>
  <script>
    import { serializeForm } from '@/common/utils/dom';
    import storage from '@/common/storage';
    import checkUA from '../check-ua';
    document.title = '風俗CTIv2：ログイン';
    export default {
      state: {
        mail: storage.getItem('mail'),
        password: storage.getItem('password'),
        saveInputCheck: storage.getItem('saveInputCheck') != '0',
      },

      onMounted() {
        const offSet = new Date().getTimezoneOffset();
        if (offSet != -540) {
          this.props.openInfoDialog('ご利用端末のタイムゾーン設定を日本に変更してください。');
        }
        if (checkUA()) {
          this.props.openInfoDialog('ブラウザのバージョンが古いため、正常に動作しない可能性があります。');
        }
      },

      togglePassword() {
        const passwordElement = this.$('#password');
        const type = passwordElement.getAttribute('type');
        this.$('#password').setAttribute('type', type == 'password' ? 'text' : 'password');
      },

      onSubmit(e) {
        e.preventDefault();
        this.$('[name=dummyemail]').value = '';
        const data = serializeForm(e.target);
        this.props.login(data);
      }
    };
  </script>
  <style type="postcss">
    .login-btn {
      margin-top: 16px;
      width: 100%;
    }

    .link-group {
      margin-top: 16px;
      text-align: center;
    }

    .link+.link {
      margin-left: 14px;
    }
  </style>
</login>